// localStorage helpers for Copy Blogs dashboard metadata that lives outside
// the scraping/article pipeline: per-source management status, last-viewed
// timestamps, and cached activity stats (latest article date / article
// count) used to drive the dashboard's status badges. Keyed globally by
// source id (a Supabase uuid, already unique across profiles) — same
// pattern as the existing `copyblogs_favorites` key — so none of this needs
// profile scoping and none of it touches copy_blogs_sources/
// copy_blogs_articles or the scraping flow itself.

const MGMT_KEY = 'copyblogs_mgmt_status';
const VIEWED_KEY = 'copyblogs_last_viewed';
const STATS_KEY = 'copyblogs_source_stats';

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
}

export const MGMT_STATUSES = {
  KEEP: 'keep',
  REVIEW: 'review',
  REMOVE_CANDIDATE: 'remove_candidate',
};

export function loadMgmtStatusMap() {
  return readJson(MGMT_KEY, {});
}

export function saveMgmtStatus(sourceId, status) {
  const map = loadMgmtStatusMap();
  map[sourceId] = status;
  writeJson(MGMT_KEY, map);
  return map;
}

export function loadLastViewedMap() {
  return readJson(VIEWED_KEY, {});
}

export function recordLastViewed(sourceId) {
  const map = loadLastViewedMap();
  map[sourceId] = new Date().toISOString();
  writeJson(VIEWED_KEY, map);
  return map;
}

export function loadStatsCache() {
  return readJson(STATS_KEY, {});
}

export function saveStatsEntry(sourceId, entry) {
  const map = loadStatsCache();
  map[sourceId] = { ...map?.[sourceId], ...entry };
  writeJson(STATS_KEY, map);
  return map;
}
